module.exports = __webpack_public_path__ + "img/status.ff6d023b.svg";